import { render, staticRenderFns } from "./RecentBuilds.vue?vue&type=template&id=c35795de&scoped=true"
import script from "./RecentBuilds.vue?vue&type=script&lang=js"
export * from "./RecentBuilds.vue?vue&type=script&lang=js"
import style0 from "./RecentBuilds.vue?vue&type=style&index=0&id=c35795de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35795de",
  null
  
)

export default component.exports